import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';
import { get_preview_baseline_binning_request } from '../../components/assays/V2Assays/conversions';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const previewBaselineBinning = ({ assayConfig = {} }) => {
  const outputConfig = get_preview_baseline_binning_request(assayConfig);

  const body = JSON.stringify(outputConfig)

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v2/api/assays/preview_baseline_binning', fetchOptions)
}

export const swrPreviewBaselineBinning = (queryParams) => {
  const [assayConfig] = queryParams;

  return previewBaselineBinning({ assayConfig })
}

export default previewBaselineBinning;
